<div class="container pd-bottom-90">
  <h1 class="title">{{ 'RESTAURANTS.TITLE' | translate }}</h1>

  <!--<div class="form-field">
    <mat-icon class="icon-search" svgIcon="search"></mat-icon>
    <input
      type="text"
      [(ngModel)]="search"
      [placeholder]="'RESTAURANTS.SEARCH' | translate"
      (input)="filterRestaurants()"
    />
    @if (search) {
      <mat-icon class="icon-clear" (click)="cancelSearch()" svgIcon="close"></mat-icon>
      <button class="btn-cancel" (click)="cancelSearch()">{{ 'BUTTONS.CANCEL' | translate }}</button>
    }
  </div>-->
  <br/>

  <div class="restaurant-grid">
    @if (isLoadingRestaurants) {
      <app-empty-state
        [title]="'SEARCH_FIELD.LOADING' | translate"
        [description]="'SEARCH_FIELD.LOADING_DESCRIPTION' | translate"
      ></app-empty-state>
    } @else {
      @for (restaurant of filteredRestaurants; track restaurant) {
        <app-restaurant-card
          [id]="restaurant.zigBarId"
          [imageLogoUrl]="restaurant.imageLogoUrl"
          [name]="restaurant.name"
          (click)="openDetailsRestaurant(restaurant.zigBarId)"
        ></app-restaurant-card>
      } @empty {
        <app-empty-state
          [title]="'SEARCH_FIELD.NO_RESULTS_FOUND' | translate"
          [description]="'SEARCH_FIELD.MISSING_RESTAURANT' | translate"
          [showSuggestion]="true"
        ></app-empty-state>
      }
    }
  </div>
</div>

<app-bottom-nav></app-bottom-nav>
